import React from "react";

const Footer = () =>{
    return(
    <>
        <footer className="w-100 bg-light text-center">
            <p>All Rights Reserved 2021</p>
        </footer>
    </>
    );
};

export default Footer;